const InsuranceSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-12">
              <div
                className="about__content"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="section-header text-center mb-0">
                  <h2 className="text-uppercase">
                    Insurance Broking <span className="style2">Firm in India</span>
                  </h2>
                  <p className="text-justify">
                    Asiatic Stock & Securities Ltd. serves as a distribution partner to all major insurance
                    companies with a wide range of insurance product offerings.
                  </p>
                </div>

                <div className="about__content-inner">
                  <h4>Why choose us?</h4>
                  <p className="text-justify">
                    With the right experience, expertise, and clients’ trust, Asiatic Stock & Securities Ltd. is
                    a preferred choice for Life Insurance needs. Every client is
                    offered an optimal alternative available in the market, ensuring
                    that all the insurance requirements are covered in that solution.
                  </p>

                  <h4>Health Insurance</h4>
                  <h6>Why Health Insurance?</h6>
                  <p className="text-justify">
                    Health is an integral part of our lives. Hence it is imperative
                    for individuals to protect their health and also insure it
                    against any unforeseen situations which might incur huge medical
                    expenses. Keeping this in mind, the Health Insurance services
                    offered at Asiatic Stock & Securities Ltd. are aligned with the decisions that clients need
                    to make regarding Health/Medical Insurance.
                  </p>
                  <h6>Why choose us?</h6>
                  <p className="text-justify">
                    At Asiatic Stock & Securities Ltd., a dedicated team looks after the insuree’s needs and
                    ensures that the insurance solution provided meets their
                    requirements in an optimal manner.
                  </p>
                  <p className="text-justify">
                    Clients’ and their family’s needs are the prime focus for us when
                    offering a solution. Hence one can be assured of a suitable and
                    convenient plan that we propose to them.
                  </p>

                  <h4>General Insurance</h4>
                  <p className="text-justify">
                    General Insurance is typically defined as any insurance that is
                    not life insurance.
                  </p>

                  <h6>Why choose us?</h6>
                  <p className="text-justify">
                    At Asiatic Stock & Securities Ltd., we provide a wide range of General Insurance products
                    that suit clients’ requirements. We offer research-based advice
                    which helps secure and protect assets from a calamity or
                    disaster. Our solution is backed by a technical team of
                    meticulous experts capable of handling both large insurance
                    portfolios as well as retail clients.
                  </p>
                  <p className="text-justify">
                    Our cover recommendations are made only after inspections,
                    scrutiny of existing insurance portfolios, and identifying areas
                    for optimization of cover and pricing.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InsuranceSection;
